/// <reference path="../../ng-services/chat.service.ts"/>

import { CopyPasteFilesService } from '../../ng-services/attachments/copy-paste-files.service';
import { ChatAttachmentUploadService } from '../../ng-services/chat-attachment-upload.service';
import { MeetingsStore } from '../../ng-services/meetings.store';

(function () {
    angular.module('tradersyard').directive('tyChatUploadPaste', [
        'MeetingsStore',
        'ChatAttachmentUploadService',
        'CopyPasteFilesService',
        function (
            meetingsStore: MeetingsStore,
            chatAttachmentUploadService: ChatAttachmentUploadService,
            copyPasteFiles: CopyPasteFilesService
        ) {
            function link(scope: ng.IScope, element: ng.IRootElementService) {
                const e = element[0];

                e.addEventListener('paste', (event: ClipboardEvent) => {
                    if (!event.clipboardData) {
                        return;
                    }

                    const files = copyPasteFiles.filesFromEvent(event);

                    if (files.length) {
                        event.preventDefault();
                        meetingsStore.activeMeeting$
                            .take(1)
                            .subscribe(
                                (meeting) =>
                                    meeting &&
                                    files.forEach((file) => chatAttachmentUploadService.upload(meeting, file as any))
                            );
                    }
                });
            }

            return {
                link,
                transclude: true,
                template: `<ng-transclude/>`,
            };
        },
    ]);
})();
